import { formatCurrency } from '@js/utilities/number.js'

// lodash components
import split from 'lodash/split'

var formatterFunctions = {
    dateFormatter: function (value) {
        const dayMonthYear = split(value, '-')
        const day = dayMonthYear[2]
        const month = dayMonthYear[1]
        const year = dayMonthYear[0]

        return process.env.territory !== 'usa' ? `${day}-${month}-${year}` : `${month}-${day}-${year}`
    },
    numericFormatter: function (value) {
        return parseInt(value)
    },
    numericBool: function (value) {
        return parseInt(value) === 1 ? 'Yes' : 'No'
    },
    monthlyAmount: function (value) {
        return parseInt(value) * 12
    },
    currencyFormat: function (value) {
        return formatCurrency(value)
    },
    monthsToYears: function (value) {
        if (isNaN(+value) || !value) {
            return value
        }

        const intValue = parseInt(value, 10)
        const years = Math.floor(intValue / 12)
        const months = intValue % 12
        const monthString = months === 1 ? 'month' : 'months'
        const yearString = years === 1 ? 'year' : 'years'

        if (years >= 1) {
            return `${years} ${yearString}` + (months ? ` and ${months} ${monthString}` : '')
        } else {
            return `${months} ${monthString}`
        }
    },
}

function format(value, formatFunction) {
    return formatterFunctions[formatFunction](value)
}

export { format }
